import { getPaddingString, toRGBA } from "../parser/utils";

export default ({ data, id, preview }) => {
  const { html, backgroundColor } = data;
  return `
    <div id="${id}" class="rip-mm-form-thankyou" style="${getPaddingString(data)};background-color: ${toRGBA(backgroundColor)};display:none;">
      ${html}
    </div>
  `;
};
